import { FunctionComponent } from 'react';
import Link from 'next/link';
import classnames from 'classnames';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutBreadCrumbs: FunctionComponent<Props> = ({ elements }) => {
    const visibleElements = elements.filter(element => element.visible !== false);
    if (visibleElements.length === 0) {
        return null;
    }

    return (
        <StyledComponent className="layout-bread-crumbs">
            {visibleElements.map(element => (
                <div
                    className={classnames({
                        'element-group': true,
                        'disabled': element?.disabled,
                        'truncate': element?.truncate,
                    })}
                    key={element.key}
                >
                    {!element?.disableDivider && (
                        <span className="element-divider">
                            {'>'}
                        </span>
                    )}
                    <Link
                        key={element.key}
                        href={element.href}
                    >
                        <a
                            className={classnames(
                                'element',
                                { active: Boolean(element.active) }
                            )}
                        >
                            {element.label}
                        </a>
                    </Link>
                </div>
            ))}
        </StyledComponent>
    );
};

export default LayoutBreadCrumbs;
